import { render, staticRenderFns } from "./ManterTipoCreditoAssuntoEditar.vue?vue&type=template&id=5b1e2df2&scoped=true&"
import script from "./ManterTipoCreditoAssuntoEditar.vue?vue&type=script&lang=js&"
export * from "./ManterTipoCreditoAssuntoEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1e2df2",
  null
  
)

export default component.exports